export function HomePage() {
  return (
    <div className="container" style={{ display: 'grid', gap: 16 }}>
      <section className="card hero">
        <div className="heroInner">
          <span className="badge">من نحن</span>
          <h1 className="h1">مركز الملاكمة الفحماوي</h1>
          <p className="lead" style={{ maxWidth: 820 }}>
            مركز الملاكمة الفحماوي هو مركز رياضي متخصص في تدريب الملاكمة، تطوير اللياقة البدنية،
            وبناء الانضباط والثقة لدى الشباب والأطفال في بيئة احترافية وآمنة.
          </p>
          <div className="actions">
            <a className="btn btnPrimary" href="/ain-khaled">
              فرع عين خالد
            </a>
            <a className="btn" href="/al-maydan">
              فرع الميدان
            </a>
          </div>
        </div>
      </section>

      <section className="grid2">
        <div className="card section" style={{ display: 'grid', gap: 12 }}>
          <div className="titleRow">
            <h2 className="h2">عن المركز</h2>
            <span className="badge">تدريب رياضي</span>
          </div>
          <p className="muted" style={{ margin: 0, lineHeight: 1.95 }}>
            نحن لا نركز فقط على التدريب البدني، بل نعمل على بناء شخصية رياضية متكاملة، تجمع بين
            القوة، الالتزام، والانضباط الذاتي.
          </p>
          <p className="muted" style={{ margin: 0, lineHeight: 1.95 }}>
            يُدار المركز بإشراف مدرب محترف يمتلك خبرة واسعة في تدريب مختلف الفئات العمرية، وقد
            ساهم في تخريج أبطال حققوا إنجازات على مستوى:
          </p>
          <ul className="muted" style={{ margin: 0, paddingInlineStart: 18, lineHeight: 2 }}>
            <li>بطولات وطنية</li>
            <li>بطولات أوروبية</li>
            <li>بطولات عالمية</li>
          </ul>
          <div className="gridCards">
            <div className="card section" style={{ boxShadow: 'none' }}>
              <div className="titleRow">
                <h3 className="h2">🎯 أهدافنا</h3>
              </div>
              <ul className="muted" style={{ margin: 0, paddingInlineStart: 18, lineHeight: 2 }}>
                <li>تطوير مهارات الملاكمة الأساسية والمتقدمة</li>
                <li>رفع مستوى اللياقة البدنية والتحمل</li>
                <li>تعزيز الثقة بالنفس والانضباط</li>
                <li>إعداد رياضيين للمنافسة في البطولات المحلية والعالمية</li>
                <li>توفير بيئة تدريب إيجابية ومحفزة</li>
              </ul>
            </div>
            <div className="card section" style={{ boxShadow: 'none' }}>
              <div className="titleRow">
                <h3 className="h2">👦👧 مناسب للأطفال والناشئين</h3>
              </div>
              <p className="muted" style={{ margin: 0, lineHeight: 1.9 }}>
                نقدم برامج تدريب مخصصة للأطفال واليافعين، تهدف إلى:
              </p>
              <ul className="muted" style={{ margin: 0, paddingInlineStart: 18, lineHeight: 2 }}>
                <li>تنمية المهارات الحركية</li>
                <li>تعزيز التركيز والانضباط</li>
                <li>بناء الثقة بالنفس منذ الصغر</li>
                <li>تعليم قيم الاحترام والعمل الجماعي</li>
              </ul>
            </div>
            <div className="card section" style={{ boxShadow: 'none' }}>
              <div className="titleRow">
                <h3 className="h2">🥇 التدريب الفردي (1:1)</h3>
              </div>
              <p className="muted" style={{ margin: 0, lineHeight: 1.9 }}>
                نوفر إمكانية التدريب الشخصي (One-on-One) مع المدرب، والذي يتيح:
              </p>
              <ul className="muted" style={{ margin: 0, paddingInlineStart: 18, lineHeight: 2 }}>
                <li>خطة تدريب مخصصة حسب المستوى والهدف</li>
                <li>متابعة دقيقة وتطوير أسرع</li>
                <li>تحسين الأداء بشكل احترافي</li>
                <li>التركيز على نقاط القوة والضعف</li>
              </ul>
            </div>
            <div className="card section" style={{ boxShadow: 'none' }}>
              <div className="titleRow">
                <h3 className="h2">💪 بيئة التدريب</h3>
              </div>
              <ul className="muted" style={{ margin: 0, paddingInlineStart: 18, lineHeight: 2 }}>
                <li>بيئة آمنة ومنظمة</li>
                <li>معدات تدريب حديثة</li>
                <li>إشراف مباشر من المدرب</li>
                <li>مناسبة لجميع المستويات (مبتدئين – متقدمين)</li>
              </ul>
            </div>
          </div>
        </div>

        <aside className="card section">
          <div className="titleRow">
            <h2 className="h2">عن المدرب</h2>
            <span className="badge">روابط</span>
          </div>
          <p className="muted" style={{ margin: 0, lineHeight: 1.95 }}>
            تابع المدرب على منصات التواصل لمشاهدة المحتوى والتحديثات.
          </p>
          <hr className="hr" />
          <div className="actions">
            <a
              className="btn btnPrimary"
              href="https://www.facebook.com/amerp3011"
              target="_blank"
              rel="noreferrer"
            >
              فيسبوك
            </a>
            <a
              className="btn"
              href="https://www.youtube.com/@ThePrince3011/videos"
              target="_blank"
              rel="noreferrer"
            >
              يوتيوب 1
            </a>
            <a
              className="btn"
              href="https://www.youtube.com/@ameragbaria7190/videos"
              target="_blank"
              rel="noreferrer"
            >
              يوتيوب 2
            </a>
          </div>
        </aside>
      </section>
    </div>
  );
}

